'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Invoices = (_temp = _class = function (_SvgIcon) {
  _inherits(Invoices, _SvgIcon);

  function Invoices() {
    _classCallCheck(this, Invoices);

    return _possibleConstructorReturn(this, (Invoices.__proto__ || Object.getPrototypeOf(Invoices)).apply(this, arguments));
  }

  _createClass(Invoices, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            {
              id: 'Icons-/-Icon-/-Invoice-Extraction',
              stroke: 'none',
              strokeWidth: '1',
              fill: 'none',
              fillRule: 'evenodd'
            },
            _react2['default'].createElement(
              'g',
              { id: 'Colors-/-Swatches-/-Transparent' },
              _react2['default'].createElement('rect', { id: 'Swatch', x: '0', y: '0', width: '64', height: '64' })
            ),
            _react2['default'].createElement(
              'g',
              { id: 'Group-33', transform: 'translate(8.500000, 9.000000)' },
              _react2['default'].createElement(
                'g',
                { id: 'Group-9', transform: 'translate(7.000000, 0.531200)' },
                _react2['default'].createElement(
                  'g',
                  { id: 'Group-3' },
                  _react2['default'].createElement(
                    'mask',
                    { id: 'mask-2', fill: 'white' },
                    _react2['default'].createElement('polygon', {
                      id: 'path-1',
                      points: '0.7969 0.469 33.7969 0.469 33.7969 44.4689 0.7969 44.4689'
                    })
                  ),
                  _react2['default'].createElement('g', { id: 'Clip-2' }),
                  _react2['default'].createElement('path', {
                    d: 'M0.7969,3.1089 C0.7969,1.6509 1.9789,0.4689 3.4369,0.4689 L22.7969,0.4689 L33.7969,9.7089 L33.7969,41.8289 C33.7969,43.2869 32.6149,44.4689 31.1569,44.4689 L3.4369,44.4689 C1.9789,44.4689 0.7969,43.2869 0.7969,41.8289 L0.7969,3.1089 Z',
                    id: 'Fill-1',
                    fill: '#EBEBEB',
                    mask: 'url(#mask-2)'
                  })
                ),
                _react2['default'].createElement('path', {
                  d: 'M5.7314,6.9644 L28.8634,6.9644 C29.9304,6.9644 30.7964,7.8304 30.7964,8.8984 L30.7964,39.0304 C30.7964,40.0984 29.9304,40.9644 28.8634,40.9644 L5.7314,40.9644 C4.6634,40.9644 3.7964,40.0984 3.7964,39.0304 L3.7964,8.8984 C3.7964,7.8304 4.6634,6.9644 5.7314,6.9644',
                  id: 'Fill-4',
                  fill: '#FFFFFF'
                }),
                _react2['default'].createElement(
                  'g',
                  { id: 'Group-8', transform: 'translate(22.000000, 0.000000)' },
                  _react2['default'].createElement(
                    'mask',
                    { id: 'mask-4', fill: 'white' },
                    _react2['default'].createElement('polygon', {
                      id: 'path-3',
                      points: '0.7969 0.469 11.7969 0.469 11.7969 9.7087 0.7969 9.7087'
                    })
                  ),
                  _react2['default'].createElement('g', { id: 'Clip-7' }),
                  _react2['default'].createElement('path', {
                    d: 'M0.7969,0.4687 L0.7969,7.0687 C0.7969,8.5277 1.9789,9.7087 3.4369,9.7087 L11.7969,9.7087 L0.7969,0.4687 Z',
                    id: 'Fill-6',
                    fill: '#CCCCCC',
                    mask: 'url(#mask-4)'
                  })
                )
              ),
              _react2['default'].createElement(
                'g',
                { id: 'Group-24', transform: 'translate(0.000000, 0.531200)' },
                _react2['default'].createElement('path', {
                  d: 'M32.8066,27.1016 C32.8066,27.6926 32.3276,28.1716 31.7376,28.1716 L28.9206,28.1716 C28.3296,28.1716 27.8506,27.6926 27.8506,27.1016 C27.8506,26.5106 28.3296,26.0316 28.9206,26.0316 L31.7376,26.0316 C32.3276,26.0316 32.8066,26.5106 32.8066,27.1016',
                  id: 'Fill-10',
                  fill: '#CCCCCC'
                }),
                _react2['default'].createElement('path', {
                  d: 'M25.3164,17.1016 C25.3164,17.6926 24.8374,18.1716 24.2464,18.1716 L16.8574,18.1716 C16.2654,18.1716 15.7874,17.6926 15.7874,17.1016 C15.7874,16.5106 16.2654,16.0316 16.8574,16.0316 L24.2464,16.0316 C24.8374,16.0316 25.3164,16.5106 25.3164,17.1016',
                  id: 'Fill-12',
                  fill: '#CCCCCC'
                }),
                _react2['default'].createElement('path', {
                  d: 'M26.2109,27.1016 C26.2109,27.6926 25.7319,28.1716 25.1409,28.1716 L16.8569,28.1716 C16.2659,28.1716 15.7869,27.6926 15.7869,27.1016 C15.7869,26.5106 16.2659,26.0316 16.8569,26.0316 L25.1409,26.0316 C25.7319,26.0316 26.2109,26.5106 26.2109,27.1016',
                  id: 'Fill-14',
                  fill: '#CCCCCC'
                }),
                _react2['default'].createElement('path', {
                  d: 'M32.8066,22.4687 C32.8066,23.0597 32.3276,23.5387 31.7376,23.5387 L16.8576,23.5387 C16.2656,23.5387 15.7866,23.0597 15.7866,22.4687 C15.7866,21.8777 16.2656,21.3987 16.8576,21.3987 L31.7376,21.3987 C32.3276,21.3987 32.8066,21.8777 32.8066,22.4687',
                  id: 'Fill-16',
                  fill: '#CCCCCC'
                }),
                _react2['default'].createElement(
                  'mask',
                  { id: 'mask-6', fill: 'white' },
                  _react2['default'].createElement('polygon', {
                    id: 'path-5',
                    points: '0 47 40.797 47 40.797 0.469 0 0.469'
                  })
                ),
                _react2['default'].createElement('g', { id: 'Clip-19' }),
                _react2['default'].createElement('path', {
                  d: 'M26.904,19.332 L33.689,19.332 L33.689,14.871 L26.904,14.871 L26.904,19.332 Z M34.189,20.332 L26.404,20.332 C26.128,20.332 25.904,20.108 25.904,19.832 L25.904,14.371 C25.904,14.095 26.128,13.871 26.404,13.871 L34.189,13.871 C34.466,13.871 34.689,14.095 34.689,14.371 L34.689,19.832 C34.689,20.108 34.466,20.332 34.189,20.332 L34.189,20.332 Z',
                  id: 'Fill-18',
                  fill: '#FC6666',
                  mask: 'url(#mask-6)'
                }),
                _react2['default'].createElement('path', {
                  d: 'M14.761,35.332 L23.789,35.332 L23.789,30.871 L14.761,30.871 L14.761,35.332 Z M24.289,36.332 L14.261,36.332 C13.984,36.332 13.761,36.108 13.761,35.832 L13.761,30.371 C13.761,30.095 13.984,29.871 14.261,29.871 L24.289,29.871 C24.565,29.871 24.789,30.095 24.789,30.371 L24.789,35.832 C24.789,36.108 24.565,36.332 24.289,36.332 L24.289,36.332 Z',
                  id: 'Fill-20',
                  fill: '#FC6666',
                  mask: 'url(#mask-6)'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-21',
                  fill: '#CCCCCC',
                  mask: 'url(#mask-6)',
                  points: '6.3311 34.3203 10.7971 45.8633 19.2331 33.5523'
                }),
                _react2['default'].createElement('path', {
                  d: 'M32.8066,17.1016 C32.8066,17.6926 32.3276,18.1716 31.7376,18.1716 L28.8206,18.1716 C28.2296,18.1716 27.7496,17.6926 27.7496,17.1016 C27.7496,16.5106 28.2296,16.0316 28.8206,16.0316 L31.7376,16.0316 C32.3276,16.0316 32.8066,16.5106 32.8066,17.1016',
                  id: 'Fill-22',
                  fill: '#5E6174',
                  mask: 'url(#mask-6)'
                }),
                _react2['default'].createElement('path', {
                  d: 'M22.6807,33.1016 C22.6807,33.6926 22.2017,34.1716 21.6107,34.1716 L16.8577,34.1716 C16.2657,34.1716 15.7867,33.6926 15.7867,33.1016 C15.7867,32.5106 16.2657,32.0316 16.8577,32.0316 L21.6107,32.0316 C22.2017,32.0316 22.6807,32.5106 22.6807,33.1016',
                  id: 'Fill-23',
                  fill: '#5E6174',
                  mask: 'url(#mask-6)'
                })
              ),
              _react2['default'].createElement(
                'g',
                { id: 'Group-32', transform: 'translate(0.000000, 32.531200)' },
                _react2['default'].createElement('path', {
                  d: 'M13.4482,7.9009 C13.4482,11.4069 10.6052,14.2499 7.0982,14.2499 C3.5932,14.2499 0.7502,11.4069 0.7502,7.9009 C0.7502,4.3949 3.5932,1.5519 7.0982,1.5519 C10.6052,1.5519 13.4482,4.3949 13.4482,7.9009',
                  id: 'Fill-25',
                  fill: '#FFFFFF'
                }),
                _react2['default'].createElement(
                  'g',
                  { id: 'Group-29' },
                  _react2['default'].createElement(
                    'mask',
                    { id: 'mask-8', fill: 'white' },
                    _react2['default'].createElement('polygon', {
                      id: 'path-7',
                      points: '0 0.8022 14.1986 0.8022 14.1986 15 0 15'
                    })
                  ),
                  _react2['default'].createElement('g', { id: 'Clip-28' }),
                  _react2['default'].createElement('path', {
                    d: 'M7.0986,2.3022 C4.0116,2.3022 1.4996,4.8142 1.4996,7.9012 C1.4996,10.9882 4.0116,13.5002 7.0986,13.5002 C10.1866,13.5002 12.6986,10.9882 12.6986,7.9012 C12.6986,4.8142 10.1866,2.3022 7.0986,2.3022 M7.0986,15.0002 C3.1846,15.0002 -0.0004,11.8152 -0.0004,7.9012 C-0.0004,3.9872 3.1846,0.8022 7.0986,0.8022 C11.0136,0.8022 14.1986,3.9872 14.1986,7.9012 C14.1986,11.8152 11.0136,15.0002 7.0986,15.0002',
                    id: 'Fill-27',
                    fill: '#112B70',
                    mask: 'url(#mask-8)'
                  })
                ),
                _react2['default'].createElement('path', {
                  d: 'M8.6143,7.4336 C8.3033,7.2946 7.9763,7.1776 7.6383,7.0856 C7.3663,7.0146 7.0993,6.9126 6.8483,6.7836 C6.7683,6.7416 6.7183,6.6556 6.7203,6.5486 C6.7183,6.4966 6.7453,6.4476 6.7813,6.4256 C6.8973,6.3616 7.0183,6.3326 7.1633,6.3356 C7.4183,6.3466 7.6693,6.3936 7.9163,6.4816 C8.2143,6.5766 8.5003,6.7076 8.7663,6.8726 L9.0063,7.0206 L9.6943,5.5316 L9.5203,5.4126 C9.2603,5.2336 8.9763,5.0916 8.6783,4.9896 C8.4373,4.9046 8.1883,4.8406 7.9363,4.7996 L7.9363,3.6986 L6.5263,3.6986 L6.5263,4.8116 C6.1093,4.8976 5.7173,5.0986 5.4013,5.3906 C5.0553,5.7176 4.8643,6.1806 4.8763,6.6406 C4.8593,7.0056 4.9683,7.3696 5.1893,7.6726 C5.3803,7.9106 5.6283,8.1026 5.9123,8.2296 C6.2233,8.3606 6.5483,8.4696 6.8693,8.5536 C7.1213,8.6256 7.3213,8.6896 7.4743,8.7506 C7.5803,8.7866 7.6763,8.8446 7.7573,8.9186 C7.8133,8.9736 7.8423,9.0486 7.8353,9.1236 C7.8273,9.2036 7.7863,9.2726 7.7353,9.3066 C7.5923,9.3866 7.4183,9.4216 7.2613,9.4146 C6.9473,9.4076 6.6433,9.3376 6.3523,9.2066 C6.0233,9.0686 5.7223,8.8766 5.4593,8.6386 L5.2123,8.4156 L4.4823,9.9166 L4.6333,10.0416 C4.9263,10.2876 5.2543,10.4896 5.6053,10.6416 C5.9013,10.7676 6.2123,10.8606 6.5303,10.9176 L6.5303,12.1036 L7.9403,12.1036 L7.9403,10.9216 C8.3693,10.8436 8.7653,10.6506 9.1023,10.3546 C9.4703,10.0136 9.6723,9.5296 9.6533,9.0486 C9.6723,8.6796 9.5613,8.3106 9.3403,8.0096 C9.1513,7.7596 8.9003,7.5606 8.6143,7.4336',
                  id: 'Fill-30',
                  fill: '#00A3F5'
                })
              )
            )
          )
        );
      }

      return render;
    }()
  }]);

  return Invoices;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = Invoices;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Invoices.js
// module id = 1381
// module chunks = 32